module.exports = __webpack_public_path__ + "img/black.d4cadc94.svg";